import React, { Component } from 'react';
import '../styles/loading.css';
import CircularProgress from 'material-ui/CircularProgress';

class Loading extends Component {
    render() {
        let classes = "flex-center position-ref";
        if (this.props && this.props.fullHeight) {
            classes += " full-height";
        }

        return (
            <div className={classes}>
                <CircularProgress size={80} thickness={5} />
            </div>
        );
    }
};

export default Loading;



// WEBPACK FOOTER //
// ./src/components/Loading.js